import { Skeleton } from "@mui/material";

const SkeletonCards = () => {
  return (
    <div className="grid gap-2 grid-cols-[repeat(auto-fit,minmax(340px,1fr))] justify-items-center">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="pet-card-size relative p-2 rounded-xl shadow-2xl flex flex-col items-center bg-white"
        >

          {/* QR (opcional) */}
          <div className="absolute p-1 rounded-md bg-white bottom-6 right-3">
            <Skeleton variant="rectangular" width={56} height={56} />
          </div>

          {/* Imagen */}
          <div className="relative w-full">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={260}
              className="rounded-xl"
            />
            <Skeleton
              variant="circular"
              width={36}
              height={36}
              className="absolute bottom-1 right-1"
            />
          </div>


          {/* Info principal */}
          <div className="w-full flex flex-col">
            <div className="flex justify-between items-center">
              <Skeleton width={120} height={32} className="px-2" />
              <Skeleton width={80} height={24} className="p-2" />
            </div>
            <div className="relative flex px-2 gap-0 flex-col w-full h-full">
              <Skeleton width={80} height={24} />
              <div className="flex items-center gap-2">
                <Skeleton width={60} height={24} />
                <Skeleton width={10} height={24} />
                <Skeleton width={60} height={24} />
              </div>
              <div className="flex flex-col justify-center">
                <Skeleton width={120} height={28} />
                <Skeleton width={80} height={24} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonCards;